export const askAiEmbedContainerClassName =
  "w-full flex flex-col rounded-lg border mb-1 prose prose-sm max-w-none empty:hidden py-2";
export const askAiEmbedItemClassName = "px-4 py-2 empty:hidden";
